import gql from "graphql-tag";

export function castListQuery(params) {
    return {
        query: gql`
            query($id: ID!) {
                result: product(id: $id) {
                    ... on Feature {
                        cast {
                            name
                            character
                        }
                    }
                    ... on Season {
                        cast {
                            name
                            character
                        }
                    }
                }
            }
        `,
        variables: params,
    };
}
